<template>
    <div class="overview" v-if="date !== null">
        <div class="page-header">
            <h1>
                Reporting&nbsp;

                <small>
                    {{date | moment("DD. MMMM \'YY")}}
                </small>

                <small>
                    <router-link :to="{name: 'reporting'}" class="btn btn-default btn-fill btn-sm">Switch to monthly</router-link>
                </small>

                <div class="pull-right">
                    <date-picker v-model="date" :config="{format: 'DD MMMM YYYY'}"></date-picker>
                </div>

                <div class="pull-right">
                    <print></print>&nbsp;
                </div>
            </h1>

            <br />

            <loader v-if="!hasLoaded"></loader>

            <template v-else>
                <div class="row">
                    <div class="col-lg-6">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="col-xs-6">
                                    Room
                                </th>

                                <th class="col-xs-6 text-right">
                                    Turnover
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr v-for="room in rooms">
                                    <td>
                                        {{room.title}}
                                    </td>

                                    <td class="text-right">
                                        <template v-if="turnovers[room.id]">
                                            <small>DKK</small> {{turnovers[room.id] | fixedNumber(2) | moneyFormat}}
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-lg-6">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="col-xs-6">
                                        Type
                                    </th>

                                    <th class="col-xs-6 text-right">
                                        Turnover
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="type in types">
                                    <td>
                                        {{type.title}}
                                    </td>

                                    <td class="text-right">
                                        <template v-if="turnoverTypes[type.id]">
                                            <small>DKK</small> {{turnoverTypes[type.id] | fixedNumber(2) | moneyFormat}}
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        VAT
                                    </td>

                                    <td class="text-right">
                                        <small>DKK</small> {{total * 0.20 | fixedNumber(2) | moneyFormat}}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <strong>Total</strong>
                                    </td>

                                    <td class="text-right">
                                        <strong><small>DKK</small> {{total | fixedNumber(2) | moneyFormat}}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .overview {
        .room {
        }

        .controls {
            > * {
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import Room from '@/components/calendar/Room'
    import Loader from '@/components/layout/Loader'
    import Print from '@/components/layout/Print'

    const moment = require('moment')

    import DatePicker from 'vue-bootstrap-datetimepicker'

    const RoomService = require('@/services/rooms/RoomService')
    const ReservationService = require('@/services/reservations/ReservationService')
    const TypeService = require('@/services/reservations/TypeService')

    export default {
        data() {
            return {
                hasLoaded: false,
                date: null,
                rooms: [],
                types: [],
                turnovers: {},
                turnoverTypes: {},
                total: 0
            }
        },

        watch: {
            date() {
                this.load()
            }
        },

        mounted() {
            this.setDefaultDate()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            load() {
                this.hasLoaded = false
                this.rooms = []
                this.types = []
                this.turnovers = {}
                this.turnoverTypes = {}
                this.total = 0

                RoomService.findAll({
                    sort: [{
                        key: 'title',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.rooms = data.rows
                })

                TypeService.findAll({
                    sort: [{
                        key: 'title',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.types = data.rows
                })

                const options = {
                    includes: ['room', 'type'],

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'arrivalBelongsToDate',
                                    value: this.date.format('YYYY-MM-DD'),
                                    operator: 'ct'
                                }
                            ]
                        }
                    ]
                }

                ReservationService.findAll(options, (response) => {
                    const data = response.data

                    data.rows.forEach((reservation) => {
                        const total = reservation.price + reservation.totalPriceBreakfast + reservation.totalProductPrice

                        const room = reservation.room

                        let turnover = (this.turnovers[room.id]) ? this.turnovers[room.id] : 0

                        turnover += total

                        this.$set(this.turnovers, room.id, turnover)

                        if (reservation.type) {
                            // Turnover types

                            const type = reservation.type

                            let turnoverType = (this.turnoverTypes[type.id]) ? this.turnoverTypes[type.id] : 0

                            turnoverType += total

                            this.$set(this.turnoverTypes, type.id, turnoverType)
                        }

                        // Total

                        this.total += total
                    })

                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader,
            Room,
            DatePicker,
            Print
        }
    }
</script>


// WEBPACK FOOTER //
// DailyReport.vue?74a7615e